var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"irisv-dropdown__bottom-slot",attrs:{"data-cy":_vm.testHooks.bottomSlot,"tabindex":"0"},on:{"keydown":function($event){return _vm.$emit('bottom-slot-keydown', $event)},"keyup":function($event){return _vm.$emit('bottom-slot-keyup', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }